import 'highlight.js/styles/github.css';
import { useEffect } from 'react';
import hljs from 'highlight.js/lib/core';
import hljsLanguages from '@utils/hljs/languages.hljs';
import { isRichTextValid } from '@utils/kontent';
import { UserFeedbackQuery } from '../../../gatsby/createPages.types';
import TableOfContents from '@components/TableOfContents/TableOfContents';
import { RichTextElementWrapper } from '@components/RichText/RichText.styles';
import Breadcrumbs from '@components/Breadcrumbs/Breadcrumbs';
import RichText, { RichTextProps } from '../RichText/RichText';
import UserFeedback from '@components/UserFeedback/UserFeedback';
import Footer from '../Footer/Footer';
import CTAMenu from '@components/CTAMenu/CTAMenu';
import {
  ContentWrapper,
  PageTitle,
  Wrapper,
} from '@components/DocumentationPage/DocumentationPage.styles';

Object.entries(hljsLanguages).forEach(([k, v]) => hljs.registerLanguage(k, v));

export interface Props {
  body: RichTextProps;
  pageContext: PageContext;
  userFeedback?: UserFeedbackQuery | null;
  ctaMenu?: Queries.LinkFragment[];
  footerContentBody?: RichTextProps;
  menuFooterContentBody?: RichTextProps;
  title: string;
}

const DocumentationPage = ({
  body,
  ctaMenu,
  footerContentBody,
  pageContext,
  title,
  userFeedback,
}: Props) => {
  const anchorLinks =
    body.modular_content?.filter(
      (item) =>
        item.__typename === 'kontent_item_anchor_heading' &&
        item.elements.hide_in_toc.value !== 'yes'
    ) || [];

  useEffect(() => {
    hljs.configure({
      ignoreUnescapedHTML: true,
    });

    hljs.highlightAll();
  }, []);

  return (
    <>
      <Wrapper>
        {!!ctaMenu?.length && <CTAMenu ctaMenu={ctaMenu} />}
        <Breadcrumbs isUsingVersion={pageContext.isUsingVersions} items={pageContext.breadcrumbs} />
        <ContentWrapper>{Boolean(title) && <PageTitle>{title}</PageTitle>}</ContentWrapper>
        {!!anchorLinks?.length && <TableOfContents links={anchorLinks} />}
        <ContentWrapper>
          {isRichTextValid(body.value) && (
            <RichTextElementWrapper>
              <RichText {...body} />
            </RichTextElementWrapper>
          )}
          {!!userFeedback && <UserFeedback {...userFeedback} />}
        </ContentWrapper>
      </Wrapper>
      <Footer richTextValue={footerContentBody?.value} />
    </>
  );
};

export default DocumentationPage;
